(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cutoff = +((window.VRN || {}).cutoff || 16);
  var toastEl, toastT;
  function toast(msg) { toastEl = toastEl || $('#vrnToast'); if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 3000); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    /* estimated delivery date (Istanbul calendar, 1–3 business days after ship day) */
    var etaEls = $$('[data-eta]');
    if (etaEls.length) {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { parts[x.type] = x.value; });
      var day = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12));
      var nextDay = function (d) { return new Date(d.getTime() + 864e5); };
      var isWork = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; };
      var ship = day;
      if (day.getUTCDay() === 0 || (+parts.hour % 24) >= cutoff) { ship = nextDay(day); }
      while (ship.getUTCDay() === 0) ship = nextDay(ship);
      var addWork = function (d, n) { var r = d; while (n > 0) { r = nextDay(r); if (isWork(r)) n--; } return r; };
      var from = addWork(ship, 1), to = addWork(ship, 3);
      var fmtD = function (d) { return d.toLocaleDateString('tr-TR', { timeZone: 'UTC', day: 'numeric' }); };
      var fmtM = function (d) { return d.toLocaleDateString('tr-TR', { timeZone: 'UTC', month: 'long' }); };
      var range = from.getUTCMonth() === to.getUTCMonth() ? fmtD(from) + '–' + fmtD(to) + ' ' + fmtM(to) : fmtD(from) + ' ' + fmtM(from) + ' – ' + fmtD(to) + ' ' + fmtM(to);
      etaEls.forEach(function (el) { var b = $('[data-eta-range]', el); if (b) b.textContent = range; el.hidden = false; });
    }

    /* share */
    $$('[data-share]').forEach(function (b) {
      b.addEventListener('click', function () {
        var data = { title: b.dataset.shareTitle, url: b.dataset.shareUrl };
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { toast('Bağlantı kopyalandı'); });
      });
    });

    /* image lightbox */
    var lb = null, lbImgs = [], lbIdx = 0;
    function lbShow(i) {
      lbIdx = (i + lbImgs.length) % lbImgs.length;
      var img = $('img', lb); img.src = lbImgs[lbIdx]; img.alt = '';
      $('[data-lb-count]', lb).textContent = (lbIdx + 1) + ' / ' + lbImgs.length;
    }
    function lbClose() { if (!lb) return; lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    function lbOpen(gallery, start) {
      lbImgs = $$('[data-slide] img', gallery).filter(function (im) { return !im.closest('[data-slide]').querySelector('video'); }).map(function (im) {
        var set = (im.getAttribute('srcset') || '').split(',').map(function (x) { return x.trim().split(' ')[0]; }).filter(Boolean);
        return set.length ? set[set.length - 1] : im.currentSrc || im.src;
      });
      if (!lbImgs.length) return;
      if (!lb) {
        lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Görsel');
        lb.innerHTML = '<button type="button" class="lb-x" aria-label="Kapat">✕</button><button type="button" class="lb-nav lb-prev" aria-label="Önceki">‹</button><img alt=""><button type="button" class="lb-nav lb-next" aria-label="Sonraki">›</button><span class="lb-count" data-lb-count></span>';
        document.body.appendChild(lb);
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lb-x')) lbClose(); });
        $('.lb-prev', lb).addEventListener('click', function () { lbShow(lbIdx - 1); });
        $('.lb-next', lb).addEventListener('click', function () { lbShow(lbIdx + 1); });
        document.addEventListener('keydown', function (e) {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbShow(lbIdx - 1); else if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
        });
      }
      lb.classList.toggle('lb-single', lbImgs.length < 2);
      lbShow(start); lb.classList.add('is-open'); document.body.style.overflow = 'hidden';
    }
    $$('[data-gallery]').forEach(function (g) {
      var open = function () { var slides = $$('[data-slide]', g), cur = 0, n = 0; slides.forEach(function (s) { var hasImg = !!$('img', s) && !$('video', s); if (s.classList.contains('is-active')) cur = n; if (hasImg) n++; }); lbOpen(g, Math.min(cur, Math.max(n - 1, 0))); };
      var z = $('[data-zoom]', g); if (z) z.addEventListener('click', open);
      $$('[data-slide] img', g).forEach(function (im) { im.style.cursor = 'zoom-in'; im.addEventListener('click', open); });
    });

  });
})();

/* gallery: play the active video, pause others, keep the active thumb in view */
(function () {
  function init() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var slides = [].slice.call(g.querySelectorAll('[data-slide]'));
      var strip = g.querySelector('.thumbs');
      function sync() {
        slides.forEach(function (s, k) {
          var v = s.querySelector('video'); var on = s.classList.contains('is-active');
          if (v) { if (on) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
          if (on && strip) { var t = strip.querySelector('[data-thumb="' + k + '"]'); if (t) strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - 8, behavior: 'smooth' }); }
        });
      }
      var mo = new MutationObserver(sync);
      slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();